import { render, staticRenderFns } from "./HomeCategories.vue?vue&type=template&id=8d765010&scoped=true"
import script from "./HomeCategories.vue?vue&type=script&lang=ts"
export * from "./HomeCategories.vue?vue&type=script&lang=ts"
import style0 from "./HomeCategories.vue?vue&type=style&index=0&id=8d765010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d765010",
  null
  
)

export default component.exports